<template>
    <div class="create-box">
        <div class="thory-top-box">
            <div class="step">01</div>
            <div class="top">
                <div class="item">
                    <span class="require">*</span>
                    <p class="input-title">考核名称</p>
                    <el-input :disabled="isDetail" v-model="form.examineName" placeholder="请输入内容"></el-input>
                </div>
                <div class="item">
                    <span class="require">*</span>
                    <p class="input-title">开始时间</p>
                    <el-date-picker :disabled="isDetail" v-model="form.beginTime" type="datetime" placeholder="选择开始时间">
                    </el-date-picker>
                </div>
                <div class="item">
                    <span class="require">*</span>
                    <p class="input-title">结束时间</p>
                    <el-date-picker :disabled="isDetail" v-model="form.endTime" type="datetime" placeholder="选择结束时间">
                    </el-date-picker>
                </div>
                <div class="item">
                    <span class="require">*</span>
                    <p class="input-title">关联班级</p>
                    <el-select :disabled="isDetail" v-model="form.refClassIds" filterable multiple placeholder="请选择">
                        <el-option v-for="item in classes" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="center">
                <span class="require">*</span>
                <p class="input-title">抽取方式</p>
                <el-radio-group :disabled="isDetail" @input="changeCategory" style="margin-left: 2.5rem;" v-model="form.extract">
                    <el-radio v-for="(item, index) in extractOptions" :key="index" :label="item.value">{{ item.label
                        }}</el-radio>
                </el-radio-group>
            </div>
            <div class="bottom" v-if="form.extract == 'subject'">
                <span class="require">*</span>
                <p class="input-title">出题方式</p>
                <el-radio-group :disabled="isDetail" @input="changeCategory" style="margin-left: 2.5rem;"
                    v-model="form.method">
                    <el-radio v-for="(item, index) in setSubOptions" :key="index" :label="item.value">{{ item.label
                        }}</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="store-box" v-if="form.extract == 'subject'">
            <div class="method-type-box" v-show="form.method == '0'">
                <div class="exam-center-box">
                    <div class="step">02</div>
                    <div class="category-box">
                        <p>题目所属分类</p>
                        <el-radio-group v-model="subCategory" @input="searchSub">
                            <el-radio v-for="(item, index) in Category" :key="index" :label="item.value">{{ item.label
                                }}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="exam-tab-box">
                        <div v-for="(item, index) in subTypeOpts" class="opt-item"
                            :class="{ 'tab-active': currentSubType == item.value }" @click="changeOpt(item)"
                            :key="index">{{
                                item.label }}</div>
                    </div>
                    <div class="random-box">
                        <div class="left-random-box">
                            <div class="table-random-box">
                                <no-data v-if="randomPages.total == 0"></no-data>
                                <div v-for="(item, index) in randomList" class="random-item" :key="index">
                                    <div class="item-left">
                                        <i class="iconfont" @click="addRandom(item)"
                                            :class="randomSelect[item.id] ? 'icon-xuanzhong' : 'icon-duoxuanweixuanzhong'"></i>
                                        <p class="index-key">{{ (index < 9 ? '0' : '') + (index + 1) }}</p>
                                    </div>
                                    <div class="item-right">
                                        <p class="item-name">{{ item.bankName }}</p>
                                        <div class="btm">
                                            <div class="item-btm">
                                                <div>所属分类：</div>
                                                <div style="width: 10rem;" class="overflow">{{ item.classifyName }}
                                                </div>
                                            </div>
                                            <div class="item-btm" style="margin-left: 2rem;">
                                                <div style="width: 7rem;">共{{ item.questionCount }}题</div>
                                            </div>
                                            <div class="item-btm statistics-sub"
                                                v-for="(item, index) in item.questionCountMap" :key="index">
                                                <div>{{ index }}：</div>
                                                <div class="overflow">{{ item }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="page-random-box" v-if="randomPages.total > 0">
                                <el-pagination :page-size="randomPages.size" :current-page="randomPages.current"
                                    background layout="prev, pager, next" @current-change="changeRandomCurrent"
                                    :total="randomPages.total">
                                </el-pagination>
                            </div>
                        </div>
                        <div class="right-random-box">
                            <div class="exam-content">
                                <div class="content">
                                    <div v-for="(item, index) in randomConfig" :key="index" class="sub-item">
                                        <p>{{ item.label }}:共</p>
                                        <p class="number-gap overflow">{{ computedSubTypeTotal(item.label) }}</p>
                                        <p>题，选取</p>
                                        <el-input-number :disabled="isDetail" controls-position="right"
                                            class="number-input-box" style="width: 12rem;"
                                            :max="computedSubTypeTotal(item.label)" :min="0"
                                            v-model="item.selectNumber"></el-input-number>
                                        <p>{{ `题, 每题` }}</p>
                                        <el-input-number :disabled="isDetail" controls-position="right" class="number-input-box"
                                            style="width: 12rem;margin: 0 1.5rem;" :min="0" 
                                            v-model="item.score"></el-input-number>
                                        <p>分，共</p>
                                        <p class="number-gap overflow">{{ item.selectNumber * item.score || 0 }}</p>
                                        <p>分</p>
                                    </div>
                                </div>
                                <div class="exam-bottom-box">
                                    <div class="item">
                                        <div class="form-item">
                                            <p>及格分数：</p>
                                            <el-input-number :disabled="isDetail" :min="0" class="number-input-box"
                                                :max="form.method == '0' ? randomTotalScore : handTotalScore"
                                                v-model="form.passScore" controls-position="right"></el-input-number>
                                            <p>分，总分{{ form.method == '0' ? randomTotalScore : handTotalScore }}分</p>
                                        </div>
                                        <div class="form-item">
                                            <p>考试时长：</p>
                                            <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                                v-model="form.examineTime" controls-position="right"></el-input-number>
                                            <p>分钟</p>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="form-item">
                                            <p>是否打乱题目顺序：</p>
                                            <el-switch :disabled="isDetail" v-model="form.isMess"></el-switch>
                                        </div>
                                        <div class="form-item" style="margin-left: 3rem;">
                                            <p>切屏次数限制:</p>
                                            <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                                v-model="form.screenLimit" controls-position="right"></el-input-number>
                                        </div>
                                    </div>
                                    <div class="form-item">
                                        <p>多选题得分机制：</p>
                                        <el-radio-group :disabled="isDetail" v-model="form.multiMade">
                                            <el-radio label="0">少选不得分</el-radio>
                                            <el-radio label="1">少选得一分</el-radio>
                                            <el-radio label="2">少选得平均分</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div class="form-item">
                                        <p>填空题得分机制：</p>
                                        <el-radio-group :disabled="isDetail" v-model="form.fillMode">
                                            <el-radio label="0">每题错一空不得分</el-radio>
                                            <el-radio label="1">每题每空平均分</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="method-type-box1" v-show="form.method == '1'">
                <div class="hand-content">
                    <div class="hand-left">
                        <div
                            style="display: flex;align-items: center;justify-content: space-between;padding: 2rem 0 1.5rem 0;">
                            <p>已选{{ handTotalNumber }}题</p>
                            <div style="display: flex;align-items: center;">
                                <el-input style="width: 20rem;" @keydown.enter.native="search" v-model="pages.keywords"
                                    placeholder="请输入名称">
                                    <template slot="prefix">
                                        <div class="search-ipt-box">
                                            <img style="cursor: pointer;width: 16px;height: auto;"
                                                src="../../../../assets/image/magSys/search.png" @click="search" alt="">
                                        </div>
                                    </template>
                                </el-input>
                                <div class="circle-box" @click.stop="openFilter">
                                    <img style="width: 16px;" src="../../../../assets/image/magSys/filter1.png"
                                        alt="">
                                </div>
                            </div>
                        </div>
                        <div class="table-content-box">
                            <Table :totalSize="pages.total" :pagination="true" :serialNumber="isDetail ? false : true"
                                :crossPage="true" @selectId="selectEvent" @selectAll="selectEvent" :operationWidth="350"
                                :currentPage="pages.current" @changeCurrentPage="changeCurrentPage"
                                @changePageSize="changePageSize" :pageSize="pages.size" navHeight=40 ref="table"
                                :tableData="tableData" :tableKey="tableKey"></Table>
                        </div>
                    </div>
                    <div class="hand-right">
                        <div class="step">02</div>
                        <div class="right-box">
                            <div v-for="(item, index) in selectSub" class="hand-item" :key="index">
                                <div class="overflow" style="display: flex;">{{ `${index}：选取` }}<div
                                        style="width: 4rem;text-align: center;">{{
                                            item.selectList.length }}</div>题每题</div>
                                <el-input-number class="number-input-box" :disabled="isDetail" controls-position="right"
                                    :min="0" style="width: 8rem;" v-model="item.score"
                                    placeholder="请输入内容"></el-input-number>
                                <div style="display: flex;">分,共<div class="overflow" 
                                        style="width: 4rem;text-align: center;">{{
                                            item.selectList.length * (item.score || 0) }}</div>分</div>
                            </div>
                        </div>
                        <div class="form-item">
                            <p>及格分数：</p>
                            <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                :max="form.method == '0' ? randomTotalScore : handTotalScore" v-model="form.passScore"
                                controls-position="right"></el-input-number>
                            <p>分，总分{{ form.method == '0' ? randomTotalScore : handTotalScore }}分</p>
                        </div>
                        <div class="form-item" style="margin-top: 2rem;">
                            <p>考试时长：</p>
                            <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                v-model="form.examineTime" controls-position="right"></el-input-number>
                            <p>分钟</p>
                        </div>
                        <div class="item">
                            <div class="form-item" style="margin-top: 2rem;">
                                <p>是否打乱题目顺序：</p>
                                <el-switch :disabled="isDetail" v-model="form.isMess"></el-switch>
                            </div>
                            <div class="form-item" style="margin-left: 3rem;margin-top: 2rem;">
                                <p>切屏次数限制：</p>
                                <el-input-number class="number-input-box" :disabled="isDetail" :min="0"
                                    v-model="form.screenLimit" controls-position="right"></el-input-number>
                            </div>
                        </div>
                        <div class="form-item" style="margin-top: 2rem;">
                            <p>多选题得分机制：</p>
                            <el-radio-group :disabled="isDetail" v-model="form.multiMade">
                                <el-radio label="0">少选不得分</el-radio>
                                <el-radio label="1">少选得一分</el-radio>
                                <el-radio label="2">少选得平均分</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="form-item" style="margin-top: 2rem;">
                            <p>填空题得分机制：</p>
                            <el-radio-group :disabled="isDetail" v-model="form.fillMode">
                                <el-radio label="0">每题错一空不得分</el-radio>
                                <el-radio label="1">每题每空平均分</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="paper-box" v-show="form.extract == 'paper'">
            <paper-store ref="paper_store" :isDetail="isDetail"></paper-store>
        </div>
        <div class="btn-box" v-if="!isDetail">
            <div class="save" v-debounce="save">保存</div>
        </div>
        <filter-assembly title="题库筛选" ref="filter_assembly">
            <template>
                <div class="filter-item">
                    <p>所属分类：</p>
                    <div class="category-box-1">
                        <div v-for="(item, index) in [{ label: '全部', value: '' }, ...Category]"
                            @click="changeSubType(item, 'handSubCategory')"
                            :class="{ active: item.value == handSubCategory }" class="category-item" :key="index">{{
                                item.label }}</div>
                    </div>
                </div>
                <div class="filter-item">
                    <p>题目类型：</p>
                    <div class="category-box-1">
                        <div v-for="(item, index) in [{ label: '全部', value: '' }, ...typeOptions]"
                            :class="{ active: item.value == subTypeWord }" @click="changeTableList(item)"
                            class="category-item" :key="index">{{ item.label }}</div>
                    </div>
                </div>
                <div class="filter-item" style="align-items: flex-start;margin-top: 0;">
                    <p style="margin-top: 3.5rem;">题库：</p>
                    <div class="category-box-1">
                        <div v-for="(item, index) in handSubStoreOptions" @click="changeStore(item)"
                            :class="{ active: item.value == handCurrentStore }"
                            style="margin-top: 3.5rem;margin-left: 2.5rem;" class="category-item" :key="index">{{
                                item.label }}</div>
                    </div>
                </div>
            </template>
        </filter-assembly>
    </div>
</template>

<script>
import { Category } from '@/utils/utils';
import { GetClassList } from '@/api/class';
import { PageSubject } from '@/api/subject';
import { BankPageList } from '@/api/subStore';
import { AddTempPaper, SaveExamine, BatchExcludeQuestion, UpdateExamine, GetExaminePaperConfig } from '@/api/examine';
import FilterAssembly from '../../../backendSys/FilterAssembly.vue';
import { getDateTime } from '@/utils/utils';
import NoData from '../../../common/NoData.vue';
import PaperStore from './PaperStore.vue';
export default {
    components: { FilterAssembly, NoData, PaperStore },
    data() {
        return {
            form: {
                course: '',
                examineName: '',
                beginTime: '',
                endTime: '',
                refClassIds: [],
                extract: 'paper',
                method: '0',
                /**及格分数 */
                passScore: 0,
                /**考试时长 */
                examineTime: 0,
                /**多选题得分机制 */
                multiMade: '2',
                /**切屏次数 */
                screenLimit: undefined,
                /**填空得分机制 */
                fillMode: '1',
                /**是否打乱题目顺序 */
                isMess: true,
            },
            testId: '',
            /**班级可选项 */
            classes: [],
            /**抽取方式可选项 */
            extractOptions: [
                {
                    label: '试题库抽取',
                    value: 'subject'
                },
                {
                    label: '试卷库抽取',
                    value: 'paper'
                },
            ],
            /**出题方式可选项 */
            setSubOptions: [
                {
                    label: '随机出题',
                    value: '0'
                },
                {
                    label: '手动出题',
                    value: '1'
                },
            ],
            /**题库类型可选项 */
            subStoreOptions: [
                {
                    label: '云题库',
                    value: '0'
                },
                {
                    label: '校企题库',
                    value: '1'
                },
                {
                    label: '个人题库',
                    value: '2'
                },
            ],
            Category,
            /**判断是否为详情 */
            isDetail: false,
            /**题目总数 */
            total: 0,
            /**资源类型 */
            dataType: '2',
            pages: {
                current: 1,
                size: 10,
                total: 0,
                keywords: '',
            },
            /**题库类型 */
            subTypeOpts: [
                {
                    label: '个人题库',
                    value: '2'
                },
                {
                    label: '校企题库',
                    value: '1'
                },
                {
                    label: '云题库',
                    value: '0'
                },
            ],
            /**题目类型过滤 */
            subTypeWord: '',
            currentSubType: '2',
            /**手动出题过滤题目所属分类 */
            handSubCategory: '',
            /**题目所属分类 */
            subCategory: Category[0].value,
            /**手动出题选取题目 */
            selectSub: {},
            tableKey: [
                { name: '题干', value: 'questionStem', },
                { name: '题型', value: 'type' },
                { name: '难易度', value: 'difficulty' },
            ],
            tableData: [],
            typeOptions: [
                {
                    label: '判断题',
                    value: '判断题'
                },
                {
                    label: '单选题',
                    value: '单选题'
                },
                {
                    label: '填空题',
                    value: '填空题'
                },
                {
                    label: '多选题',
                    value: '多选题'
                },
            ],
            /**手动出题题库可选项 */
            handSubStoreOptions: [],
            /**随机出题列表分页 */
            randomPages: {
                current: 1,
                size: 10,
                total: 0
            },
            /**随机出题列表数据 */
            randomList: [],
            /**随机列表已选项存储 */
            randomSelect: {},
            /**随机选择题目的分数设置 */
            randomConfig: [
                {
                    label: '判断题',
                    selectNumber: 0,
                    score: 0
                },
                {
                    label: '填空题',
                    selectNumber: 0,
                    score: 0
                },
                {
                    label: '单选题',
                    selectNumber: 0,
                    score: 0
                },
                {
                    label: '多选题',
                    selectNumber: 0,
                    score: 0
                },
            ],
            /**手动选题当前所选题库 */
            handCurrentStore: '',
            /**手动题库题目列表 */
            handSubTableList: [],
            operation: ''
        }
    },
    computed: {
        /**手动选题数量 */
        handTotalNumber() {
            var sum = 0;
            for (let key in this.selectSub) {
                sum = sum + this.selectSub[key].selectList.length;
            }
            return sum;
        },
        /**随机选题总分 */
        randomTotalScore() {
            var sum = 0;
            this.randomConfig.forEach(item => {
                sum = sum + item.selectNumber * (item.score||0);
            })
            return sum;
        },
        /**手动选题总分 */
        handTotalScore() {
            var sum = 0;
            for (let key in this.selectSub) {
                sum = sum + this.selectSub[key].selectList.length * this.selectSub[key].score;
            }
            return sum;
        },
    },
    methods: {
        /**切换题库类型 */
        changeOpt(item) {
            this.currentSubType = item.value;
            this.searchSub();
        },
        /**获取班级 */
        getClassList() {
            let params = {
                classCode: "",
                className: ""
            };
            GetClassList(params).then(res => {
                if (res.code == 200) {
                    this.classes = res.data.map(item => {
                        return {
                            label: item.className,
                            value: item.id
                        }
                    })
                }
            })
        },
        /**通过考核id获取试卷配置 */
        getExaminePaperConfig(id) {
            GetExaminePaperConfig({ id }).then(res => {
                if (res.code == 200) {
                    let dialog = this.$refs.paper_store;
                    if (dialog) {
                        dialog.form.passScore = res.data.passMark;
                        dialog.form.isMess = res.data.shuffleOrder ? false : true;
                        dialog.form.examineTime = res.data.testDuration;
                        dialog.form.multiMade = res.data.multipleScoringMechanism;
                        dialog.form.fillMode = res.data.summaryScoringMechanism;
                        res.data.randomQuestionConf.forEach(item => {
                            let el = dialog.randomConfig.find(e => e.label == item.questionType);
                            if (el) {
                                el.score = item.questionScore;
                            }
                        })
                    }
                }
            })
        },
        /**批量排除题目 */
        batchExcludeQuestion(examineId) {
            let dom = this.$refs.paper_store;
            if (!dom) return;
            if(dom.clearQuestionIds.length==0)return;
            let params = {
                "examineId": examineId,
                "questionInfoList": dom.clearQuestionIds
            }
            BatchExcludeQuestion(params);
        },
        /**新增考核 */
        saveExamine(id) {
            let sum = 0;
            if (this.form.method == '0') {
                this.randomConfig.forEach(item => {
                    sum = sum + item.selectNumber * item.score;
                })
            } else {
                for (let key in this.selectSub) {
                    sum = sum + this.selectSub[key].score * this.selectSub[key].selectList.length;
                }
            }
            let params = {
                "answerTime": this.form.examineTime,
                "beginTime": getDateTime(new Date(this.form.beginTime).getTime()),
                "endTime": getDateTime(new Date(this.form.endTime).getTime()),
                "examineName": this.form.examineName,
                "examineType": 0,
                "extractionMode": 0,
                "screenLimit": this.form.screenLimit==undefined?null:this.form.screenLimit,
                "fullScore": sum,
                "passScore": this.form.passScore,
                "refClassIds": this.form.refClassIds,
                "refResourceDetails": [
                    {
                        "fullScore": sum,
                        "refResourceId": id,
                        "resourceType": 0,
                        "scoreRatio": 100
                    }
                ],
            };
            SaveExamine(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "新增考核成功",
                        type: "success",
                    });
                    this.$store.commit('course/changeOperation', '');
                    this.$store.commit('backend/changeOptlabel', '');
                    this.$emit('add_success');
                }
            })
        },
        /**修改考核 */
        updateExamine(id) {
            let sum = 0;
            if (this.form.method == '0') {
                this.randomConfig.forEach(item => {
                    sum = sum + item.selectNumber * item.score;
                })
            } else {
                for (let key in this.selectSub) {
                    sum = sum + this.selectSub[key].score * this.selectSub[key].selectList.length;
                }
            }
            let params = {
                "id": this.testId,
                "answerTime": this.form.examineTime,
                "beginTime": getDateTime(new Date(this.form.beginTime).getTime()),
                "endTime": getDateTime(new Date(this.form.endTime).getTime()),
                "examineName": this.form.examineName,
                "examineType": 0,
                "fullScore": sum,
                "screenLimit": this.form.screenLimit==undefined?null:this.form.screenLimit,
                "passScore": this.form.passScore,
                "refClassIds": this.form.refClassIds,
                "refResourceDetails": [
                    {
                        "fullScore": sum,
                        "refResourceId": id,
                        "resourceType": 0,
                        "scoreRatio": 100
                    }
                ],
            };
            UpdateExamine(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "新增考核成功",
                        type: "success",
                    });
                    this.$store.commit('course/changeOperation', '');
                    this.$store.commit('backend/changeOptlabel', '');
                    this.$emit('add_success');
                }
            })
        },
        /**手动选题切换题目类型 */
        changeTableList(item) {
            this.subTypeWord = item.value;
            this.search();
        },
        /**切换题库 */
        changeStore(item) {
            this.handCurrentStore = item.value;
            this.search();
        },
        /**计算随机出题每种类型的题目总数 */
        computedSubTypeTotal(type) {
            let sum = 0;
            for (let key in this.randomSelect) {
                let count = this.randomSelect[key].questionCountMap[type];
                if (count) {
                    sum = sum + count;
                }
            }
            return sum;
        },
        /**添加随机题目 */
        addRandom(item) {
            if (this.isDetail) return;
            if (!this.randomSelect[item.id]) {
                this.$set(this.randomSelect, item.id, item);
            } else {
                this.$delete(this.randomSelect, item.id);
            }
        },
        /**获取题库 */
        bankPageList() {
            let params = {
                "bankName": '',
                "classifyCode": this.subCategory,
                "current": this.randomPages.current,
                "dataType": this.currentSubType,
                "size": this.randomPages.size
            };
            BankPageList(params).then(res => {
                if (res.code == 200) {
                    this.randomList = res.data.records;
                    this.randomPages.total = res.data.total;
                }
            })
        },
        /**搜索题库 */
        searchSub() {
            this.randomPages.current = 1;
            this.bankPageList();
        },
        /**随机出题翻页 */
        changeRandomCurrent(e) {
            this.randomPages.current = e;
            this.bankPageList();
        },
        /**切换列表题目类型 */
        changeSubType(item, type) {
            this[type] = item.value;
            this.queryStore();
        },
        /**打开过滤弹窗 */
        openFilter() {
            var dialog = this.$refs.filter_assembly;
            if (dialog) {
                dialog.show = !dialog.show;
            }
        },
        /**切换所属分类 */
        changeCategory() {
            if (this.form.method == '1') {
                this.queryStore();
            } else {
                this.searchSub();
            }
        },
        /**计算分数 */
        computedScore(chooseSubNumber, score) {
            return chooseSubNumber * score;
        },
        /**获取题库列表数据 */
        pageSubject() {
            return new Promise(resolve => {
                var params = {
                    "classifyCode": this.handSubCategory,
                    "current": this.pages.current,
                    'dataType': this.dataType,
                    "openData": 0,
                    "questionStem": this.pages.keywords,
                    "questionBankId": this.handCurrentStore,
                    "size": this.pages.size,
                    "type": this.subTypeWord
                }
                PageSubject(params).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.records;
                        this.pages.total = res.data.total;
                        var tableDom = this.$refs.table;
                        if (tableDom) {
                            tableDom.rowChecked();
                        }
                        resolve();
                    }
                })
            })
        },
        /**初始化手动勾选题目 */
        initChooseSub() {
            var tableDom = this.$refs.table;
            if (tableDom) {
                var arr = [];
                var obj = {};
                for (let key in this.selectSub) {
                    var selectList = this.selectSub[key].selectList;
                    if (selectList) {
                        arr = [...arr, ...selectList];
                    }
                }
                arr.forEach(item => {
                    obj[item.id] = item;
                })
                tableDom.initSelection(obj);
                tableDom.rowChecked();
            }
        },
        /**获取手动出题题库过滤 */
        queryStore() {
            let params = {
                "bankName": '',
                "classifyCode": this.handSubCategory,
                "dataType": '',
                "current": 1,
                "size": 1000
            };
            BankPageList(params).then(res => {
                if (res.code == 200) {
                    this.handSubStoreOptions = res.data.records.map(item => {
                        return {
                            label: item.bankName,
                            value: item.id
                        }
                    });
                    if (this.handSubStoreOptions.length > 0) {
                        this.handCurrentStore = this.handSubStoreOptions[0].value;
                        this.search();
                    }
                }
            })
        },
        /**搜索题库列表 */
        search() {
            this.pages.current = 1;
            this.pageSubject();
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.pageSubject();
        },
        changePageSize(e) {
            this.pages.size = e;
            this.pages.current = 1;
            this.pageSubject();
        },
        /**手动选择题目 */
        selectEvent(data) {
            for (let key in this.selectSub) {
                this.selectSub[key].selectList = [];
            }
            data.forEach(item => {
                if (this.selectSub[item.type]) {
                    this.selectSub[item.type].selectList.push(item);
                } else {
                    this.$set(this.selectSub, item.type, { selectList: [item], score: 0 });
                }
            })
        },
        /**非空校验 */
        verification(){
            let obj={
                examineName:'考核名称',
                beginTime:'开始时间',
                endTime:'结束时间',
            }
            for(let key in obj){
                if(!this.form[key]){
                    this.$msg({
                        showClose: true,
                        message: obj[key]+'不能为空',
                        type: "warning",
                    });
                    return false;
                }
            }
            if(this.form.refClassIds.length==0){
                this.$msg({
                        showClose: true,
                        message:'关联班级不能为空',
                        type: "warning",
                    });
                return false;
            }
            let beginTime = new Date(this.form.beginTime).getTime();
            let endTime = new Date(this.form.endTime).getTime();
            if (endTime <= beginTime) {
                this.$msg({
                    showClose: true,
                    message: "结束时间不能小于等于开始时间",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        /**保存 */
        save() {
            if(!this.verification())return;
            if (this.form.extract == 'paper') {
                let dom = this.$refs.paper_store;
                if (dom) {
                    if(dom.form.passScore <= 0){
                        this.$msg({
                            showClose: true,
                            message: '及格分数不能为0',
                            type: "warning"
                        });
                        return;
                    }
                    if(dom.form.examineTime <= 0){
                        this.$msg({
                            showClose: true,
                            message: '考试时长不能为0',
                            type: "warning"
                        });
                        return;
                    }
                    let arr = [];
                    for(let item of dom.randomConfig){
                        if(dom.querySubTotal[item.label]>0&&item.score==0){
                            this.$msg({
                            showClose: true,
                            message: item.label+'题目分数不能设置为0',
                            type: "warning",
                        });
                            return;
                        }
                        let obj = {};
                        obj.questionCount = dom.querySubTotal[item.label];
                        obj.questionScore = item.score;
                        obj.questionType = item.label;
                        arr.push(obj);
                    }
                    let data = {
                        "answerTime": dom.form.examineTime,
                        "beginTime": getDateTime(new Date(this.form.beginTime).getTime()),
                        "endTime": getDateTime(new Date(this.form.endTime).getTime()),
                        "examineName": this.form.examineName,
                        "examineType": 0,
                        "extractionMode": 1,
                        "fullScore": dom.computedTotalScore,
                        "passScore": dom.form.passScore,
                        "refClassIds": this.form.refClassIds,
                        "refResourceDetails": [],
                        "screenLimit": dom.form.screenLimit==undefined?null:dom.form.screenLimit,
                        "testPaperConfigPO": {
                            "multipleScoringMechanism": dom.form.multiMade,
                            "passMark": dom.form.passScore,
                            "randomQuestionConf": arr,
                            "shuffleOrder": dom.form.isMess ? 1 : 0,
                            "summaryScoringMechanism": dom.form.fillMode,
                            "testDuration": dom.form.examineTime,
                            "testPaperName": ''
                        }
                    };
                    for (let key in dom.currentPaperIds) {
                        let obj = {
                            fullScore: dom.currentPaperIds[key].totalScore,
                            refResourceId: key,
                            resourceType: 0,
                            scoreRatio: 0
                        };
                        data.refResourceDetails.push(obj);
                    }
                    if (!this.testId) {
                        SaveExamine(data).then(res => {
                            if (res.code == 200) {
                                this.batchExcludeQuestion(res.data);
                                this.$msg({
                                    showClose: true,
                                    message: "新增考核成功",
                                    type: "success",
                                });
                                this.$store.commit('course/changeOperation', '');
                                this.$store.commit('backend/changeOptlabel', '');
                                this.$emit('add_success');
                            }
                        })
                    } else {
                        data.id = this.testId;
                        UpdateExamine(data).then(res => {
                            if (res.code == 200) {
                                this.batchExcludeQuestion(res.data);
                                this.$msg({
                                    showClose: true,
                                    message: "修改考核成功",
                                    type: "success",
                                });
                                this.$store.commit('course/changeOperation', '');
                                this.$store.commit('backend/changeOptlabel', '');
                                this.$emit('add_success');
                            }
                        })
                    }
                }
                return;
            }
            if (this.form.passScore <= 0) {
                this.$msg({
                    showClose: true,
                    message: "及格分数不能为0",
                    type: "warning",
                });
                return;
            }
            if(this.form.examineTime==0){
                this.$msg({
                    showClose: true,
                    message: "考试时长不能为0",
                    type: "warning",
                });
                return;
            }
            var params = {
                testPaperName: this.form.examineName,
                type: 'TEMP',
                setQuestionMode: this.form.method,
                passMark: this.form.passScore,
                testDuration:this.form.examineTime,
                multipleScoringMechanism: this.form.multiMade,
                summaryScoringMechanism: this.form.fillMode,
                shuffleOrder: this.form.isMess ? 1 : 0
            };
            if (this.form.method == '0') {
                let arr = [];
                for (let key in this.randomSelect) {
                    arr.push(key);
                }
                let questionArr = []
                for(let item of this.randomConfig){
                    if(item.selectNumber>0&&item.score==0){
                        this.$msg({
                            showClose: true,
                            message: item.label+"分数不能设置为0",
                            type: "warning",
                        });
                        return;
                    }
                    if (item.selectNumber) {
                        let obj = {};
                        obj.questionBankIdList = arr;
                        obj.questionCount = item.selectNumber;
                        obj.questionType = item.label;
                        obj.questionScore = item.score;
                        questionArr.push(obj);
                    }
                }
                params.randomQuestionConfPO = questionArr;
            } else {
                var arr = [];
                for (let key in this.selectSub) {
                    this.selectSub[key].selectList.forEach(item => {
                        var obj = {};
                        obj.questionId = item.id;
                        obj.questionScore = this.selectSub[key].score;
                        obj.questionType = key;
                        arr.push(obj);
                    })
                }
                params.manualQuestionConfPO = arr;
            }
            if (!this.testId) {
                AddTempPaper(params).then(res => {
                    if (res.code == 200) {
                        this.saveExamine(res.data);
                    }
                })
            } else {
                AddTempPaper(params).then(res => {
                    if (res.code == 200) {
                        this.updateExamine(res.data);
                    }
                })
            }
        },
        /**初始化试卷库抽取编辑 */
        initPaperEdit(data) {
            this.form.refClassIds = data.classInfoList.map(item => item.id);
            this.form.examineName = data.examineName;
            this.form.classifyCode = data.classifyCode;
            this.form.beginTime = data.beginTime;
            this.form.endTime = data.endTime;
            this.form.extract = 'paper';
            this.getExaminePaperConfig(data.id);
            this.$nextTick(() => {
                let dialog = this.$refs.paper_store;
                if (dialog) {
                    var obj = {};
                    data.paperDetailList && data.paperDetailList.forEach(item => {
                        item.questionCountMap = item.questionMap;
                        obj[item.id] = item;
                    })
                    dialog.currentPaperIds = obj;
                    dialog.form.passScore = data.passScore;
                    dialog.form.screenLimit = data.screenLimit;
                    var obj1 = {};
                    data.excludeQuestionIds.forEach(item => {
                        let o = {
                            questionId: item.questionId,
                            questionType: item.questionId,
                            testPaperId: item.testPaperId
                        }
                        dialog.clearQuestionIds.push(o);
                        if (obj1[item.testPaperId] == undefined) {
                            let typeObj = {
                                '判断题': 0,
                                '填空题': 0,
                                '单选题': 0,
                                '多选题': 0
                            }
                            obj1[item.testPaperId] = typeObj;
                        }
                        obj1[item.testPaperId][item.questionType]++;
                    })
                    dialog.excludeSub = obj1;
                    dialog.paperQuestionPageList();
                }
            })
        },
        /**初始化试题库抽取编辑 */
        async initEditData(data) {
            this.initSelect();
            this.form.refClassIds = data.classInfoList.map(item => item.id);
            this.form.examineName = data.testPaperName;
            this.form.classifyCode = data.classifyCode;
            this.form.extract = 'subject';
            this.form.beginTime = data.beginTime;
            this.form.endTime = data.endTime;
            this.form.screenLimit = data.screenLimit==null?undefined:data.screenLimit;
            this.form.method = data.setQuestionMode;
            this.form.passScore = data.passMark;
            this.form.examineTime = data.testDuration;
            this.form.multiMade = data.multipleScoringMechanism;
            this.form.fillMode = data.summaryScoringMechanism;
            this.form.isMess = data.shuffleOrder ? true : false;
            this.changeCategory();
            if (this.form.method == '0') {
                data.randomQuestionConfPO.forEach(item => {
                    let el = this.randomConfig.find(e => e.label == item.questionType);
                    if (el) {
                        el.selectNumber = item.questionCount;
                        el.score = item.questionScore;
                    }
                });
                let obj = {};
                for (let key in data.questionBankCountMap) {
                    obj[key] = {
                        questionCountMap: data.questionBankCountMap[key]
                    }
                }
                this.randomSelect = obj;
            } else {
                data.manualQuestionConfPO.forEach(item => {
                    var obj = this.selectSub[item.questionType];
                    if (obj) {
                        obj.selectList.push({ id: item.questionId, type: item.questionType });
                        obj.score = item.questionScore;
                    }
                })
                this.$nextTick(() => {
                    this.initChooseSub();
                })
            }
        },
        initSelect() {
            this.typeOptions.forEach(item => {
                var obj = {
                    score: 0,
                    selectList: []
                }
                this.$set(this.selectSub, item.value, obj);
            })
        },
    },
    mounted() {
        this.getClassList();
    }
}
</script>

<style lang="less" scoped>
.create-box {
    height: 100%;
    color: #334681;

    .thory-top-box {
        background: #ffffff;
        border: 1px solid #e0e8f2;
        border-radius: 16px;
        padding: 2.5rem 5rem;
        position: relative;

        .top {
            display: flex;
            align-items: center;

            .item {
                display: flex;
                align-items: center;

                .input-title {
                    margin-right: 2.5rem;
                }
            }

            &> :nth-child(n) {
                margin-left: 8.5rem;
            }

            &> :nth-child(1) {
                margin-left: 0;
            }
        }
    }
}

.require {
    font-size: 12px;
    color: #FF0000;
}

.center,
.bottom {
    display: flex;
    align-items: center;
    margin-top: 3.5rem;
}

.exam-box {
    color: #334681;
    position: relative;
}

.step {
    width: 3rem;
    height: 3rem;
    background: #387dff;
    border: 1px solid #e0e8f2;
    border-radius: 0px 16px 0px 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FEFEFE;
    font-weight: 700;
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 0;
}

.exam-box {
    height: 100%;
    overflow: auto;

    &> :nth-child(n) {
        position: relative;

        .step {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}

.exam-top-box {
    height: 20rem;
    background: #ffffff;
    border: 1px solid #e0e8f2;
    border-radius: 16px;
    padding: 2.5rem 4rem;
}

.exam-center-box {
    height: 100%;
    position: relative;
    background: #ffffff;
    border: 1px solid #e0e8f2;
    border-radius: 16px;
    margin-top: 1.5rem;
}

.exam-bottom-box {
    margin-top: 3rem;
    display: flex;
    flex-direction: column;

    &> :nth-child(n) {
        margin-top: 2rem;
    }
}

/deep/.el-tabs__nav-wrap {
    padding: 0 2rem;
}

.exam-tab-box {
    height: 5rem;
    background: #fbfcff;
    border-bottom: 1px solid #e0e8f2;
    border-radius: 16px 16px 0px 0px;
    padding: 0 2rem;
    display: flex;
    align-items: center;

    .opt-item {
        color: #334681;
        margin-left: 4rem;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.3s;
        border-bottom: 3px solid transparent;
    }
}

.tab-active {
    border-bottom: 3px solid var(--blue) !important;
    font-size: 16px;
    font-weight: 700;
    color: var(--blue) !important;
}

.category-box {
    position: absolute;
    left: 50rem;
    top: 0;
    display: flex;
    height: 5rem;
    align-items: center;

    p {
        color: #334681;
        margin-right: 3rem;
    }
}

.first-input-box {
    display: flex;
    color: #334681;

    &> :nth-child(n) {
        margin-left: 5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.input-item {
    color: #334681;
    display: flex;
    align-items: center;
}

.red {
    color: #f56c6c;
    margin-right: 0.5rem;
}

.item {
    display: flex;
}

.form-item {
    display: flex;
    align-items: center;
}

.exam-content {
    height: 100%;
    padding: 2.5rem 6rem;
    overflow: auto;
}

.sub-item {
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.banner-title {
    text-align: center;
    font-size: 16px;
}

.store-box {
    height: calc(100% - 28rem);
}

.paper-box {
    height: calc(100% - 22.6rem);
    margin-top: 1.5rem;
}

.method-type-box {
    height: 100%;
}

.method-type-box1 {
    height: 100%;
}

.hand-content {
    border: 1px solid #e0e8f2;
    border-radius: 16px;
    margin-top: 1.5rem;
    height: 100%;
    background-color: #ffffff;
    display: flex;

    .hand-left {
        width: 60%;
        height: 100%;
        border-right: 1px solid #e0e8f2;
        padding: 0 2.5rem;
    }

    .hand-right {
        width: 40%;
        height: 100%;
        padding: 3rem 3rem 3rem 3rem;
        position: relative;
        overflow: auto;
    }
}

.search-ipt-box {
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}

.circle-box {
    width: 4rem;
    height: 4rem;
    background: rgba(56, 125, 255, 0.00);
    border: 1px solid #e0e8f2;
    border-radius: 1rem;
    margin-left: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.table-content-box {
    height: calc(100% - 10rem);
}

.hand-item {
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    font-size: 14px;
}

.right-box {
    margin-bottom: 5rem;
}

/deep/.el-input--prefix .el-input__inner {
    padding-left: 4rem;
}

.btn-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.5rem;

    .save {
        width: 8.8rem;
        height: 4rem;
        background-color: var(--blue);
        border-radius: 0.8rem;
    }
}

.number-gap {
    width: 4rem;
    text-align: center;
    color: var(--blue);
}

.number-input-box {
    margin: 0 1.5rem;
    width: 12rem !important;
}

/deep/.el-input__inner {
    border-radius: 1rem;
}

/deep/.el-input-number.is-controls-right .el-input-number__increase {
    border-radius: 0 1rem 0 0 !important;
}

/deep/.el-input-number.is-controls-right .el-input-number__decrease {
    border-radius: 0 0 1rem !important;
}

/deep/.filter-box {
    position: absolute !important;
    right: 0;
    top: 0;
}

.filter-item {
    color: #8590B3;
    font-size: 12px;
    display: flex;
    align-items: center;

    &> :nth-child(1) {
        width: 8rem;
        margin-right: 1rem;
    }
}

.category-box-1 {
    display: flex;
    flex-wrap: wrap;

    &> :nth-child(n) {
        margin-left: 3.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }

    .category-item {
        padding: 0.2rem 1rem;
        border-radius: 1rem;
        color: #334681;
        background-color: transparent;
        cursor: pointer;
    }
}

.active {
    color: #ffffff !important;
    background-color: var(--blue) !important;
}

.random-box {
    height: calc(100% - 5rem);
    display: flex;

    .left-random-box {
        width: 94rem;
        border-right: 1px solid #e0e8f2;
        padding: 2.5rem 3rem;

        .table-random-box {
            height: calc(100% - 5.2rem);
            overflow: auto;
            border: 1px solid #e0e8f2;
            border-radius: 1rem;

            .random-item {
                display: flex;
                padding: 1.5rem 4rem;
                border-bottom: 1px solid #e0e8f2;

                .item-left {
                    display: flex;

                    i {
                        margin-right: 1.5rem;
                        font-size: 16px;
                        cursor: pointer;
                    }
                }

                .item-right {
                    margin-left: 2rem;

                    .item-name {
                        font-size: 16px;
                        font-weight: 700;
                    }
                }
            }
        }

        .page-random-box {
            padding: 2.5rem;
            display: flex;
            justify-content: center;
        }
    }

    .right-random-box {
        width: calc(100% - 94rem);
    }
}

.btm {
    display: flex;
    align-items: center;
    margin-top: 1rem;
}

.item-btm {
    display: flex;
    color: #8590B3;
}

.statistics-sub {
    margin-left: 1.5rem;

    &> :nth-child(2) {
        width: 4rem;
    }
}

.index-key {
    width: 4rem;
}

.icon-duoxuanweixuanzhong {
    color: #C8D1DD;
}

.icon-xuanzhong {
    color: var(--blue);
}

/deep/.el-select__tags {
    max-height: 4rem !important;
    overflow-y: auto !important;
}
</style>